export default __webpack_public_path__ + "static/media/menu-logo@2x.8ce7e505.png";